import { render } from "./UsersTable.vue?vue&type=template&id=486cac51"
import script from "./UsersTable.vue?vue&type=script&lang=js"
export * from "./UsersTable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe-registry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__